import { VariableType } from 'json-to-graphql-query';

import { PaymentPack } from '@/interfaces/paymentPack';
import { EntityResource } from './entity.resource';

/**
 * Resource paczek płatności
 *
 * @export
 * @class PaymentPackResource
 * @extends {EntityResource<PaymentPack>}
 */
export class PaymentPackResource extends EntityResource<PaymentPack> {
  public getFields = {
    id: true,
    number: true
  };

  public listFields = {
    id: true,
    created: true,
    employeesCount: true,
    externalId: true,
    number: true,
    total: true,
    date: true,
    receivedFundsDate: true,
    status: true,
    systemNumbers: true,
    type: true,
    structure: {
      id: true,
      name: true
    }
  };

  protected listVariables = { filters: 'PaymentPackFilters!' };

  constructor() {
    super({ entityName: 'paymentPack' });
  }

  /**
   * Przesyła paczkę do MDOK
   *
   * @param {number} id
   * @returns {Promise<boolean>}
   * @memberof PaymentPackResource
   */
  public sendToMdok(id: number): Promise<boolean> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { id: 'Int!' },
        paymentPackSendToMdok: { __args: { id: new VariableType('id') } }
      }
    });
    return this.mutation({ mutation, variables: { id } }, 'paymentPackSendToMdok');
  }

  /**
   * Przesyła paczkę do KSAT
   *
   * @param {number} id
   * @returns {Promise<boolean>}
   * @memberof PaymentPackResource
   */
  public sendToKsat(id: number): Promise<boolean> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { id: 'Int!' },
        paymentPackSendToKsat: { __args: { id: new VariableType('id') } }
      }
    });
    return this.mutation({ mutation, variables: { id } }, 'paymentPackSendToKsat');
  }

  /**
   * Zatwierdzenie paczki
   *
   * @param {number} id
   * @returns {Promise<boolean>}
   * @memberof PaymentPackResource
   */
  public confirm(id: number): Promise<boolean> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { id: 'Int!' },
        paymentPackConfirm: { __args: { id: new VariableType('id') } }
      }
    });
    return this.mutation({ mutation, variables: { id } }, 'paymentPackConfirm');
  }

  /**
   * Odtwierdzenie paczki
   *
   * @param {number} id
   * @returns {Promise<boolean>}
   * @memberof PaymentPackResource
   */
  public unconfirm(id: number): Promise<boolean> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { id: 'Int!' },
        paymentPackUnconfirm: { __args: { id: new VariableType('id') } }
      }
    });
    return this.mutation({ mutation, variables: { id } }, 'paymentPackUnconfirm');
  }
}

export const paymentPackResource = new PaymentPackResource();
